
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 107.387 121.769"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Calque 2"}},[_c('path',{attrs:{"fill":"#d3d3d3","d":"M57.836 42.451l27.433 62.814H59.233l-1.397-62.814z"}}),_c('path',{attrs:{"fill":"none","stroke":"#79787d","stroke-miterlimit":"10","stroke-width":".363","d":"M17.02 114.746v-5.409H.223v5.409M8.622 109.337v5.409"}}),_c('path',{attrs:{"d":"M85.78 113.907a14.814 14.814 0 0111.636-7.523c8.632-1.05 13.275-3.384 6.638 4.92","fill":"none","stroke":"#79787d","stroke-miterlimit":"10","stroke-width":".372"}}),_c('path',{attrs:{"d":"M81.57 113.488l-5.552-4.283H24.176v5.492s45.749 0 57.393-1.209z","fill":"#0177be"}}),_c('path',{attrs:{"fill":"#8dc2e2","d":"M24.176 109.205l-2.525.049v-2.103H75.85v2.054H24.176z"}}),_c('path',{attrs:{"fill":"#85bee0","d":"M27.711 110.84h5.386v2.402h-5.386zM37.17 110.84h5.386v2.402H37.17zM46.629 110.84h5.386v2.402h-5.386zM56.089 110.84h5.386v2.402h-5.386z"}}),_c('path',{attrs:{"fill":"#8dc2e2","d":"M55.143 0h2.693v107.821h-2.693z"}}),_c('path',{attrs:{"fill":"#d3d3d3","d":"M55.143 8.265L10.565 102.49h42.308l2.27-94.225z"}}),_c('path',{attrs:{"fill":"#f2f2f2","d":"M57.836 9.202l2.153 75.128 46.774 20.935L57.836 9.202z"}}),_c('path',{attrs:{"d":"M0 114.614s90.563 1.006 104.65-3.774c0 0-5.03 10.566-8.3 10.817s-88.048 0-88.048 0-5.222.112-8.302-7.043z","fill":"#0177be"}})])])
          )
        }
      }
    